
<component :is="tag">
  <template v-if="isList">
    <template v-for="v in computedListValue">
      {{v}} <br />
    </template>
  </template>
  <template v-else>
    {{value}}
  </template>
</component>
